/* ==========================================================================
   Adapter / Clamp Quiz
   Replaces the RevenueHunt "Product Recommendation Quiz" app block.

   The branching table is NOT held here. Every answer button carries its own
   data-acq-goto="<step id>", so the routing lives next to the copy it belongs
   to in snippets/adapter-clamp-quiz.liquid and the two cannot drift apart.

   All steps are rendered server-side and hidden; this only toggles which one
   is visible. With JS disabled the snippet falls back to showing every step
   in sequence (see the <noscript> rule in the snippet).
   ========================================================================== */

(function () {
  'use strict';

  var INSTANCE_SELECTOR = '[data-acq]';

  function AdapterClampQuiz(root) {
    this.root = root;
    this.steps = {};
    this.history = [];
    this.startId = root.getAttribute('data-acq-start');

    var nodes = root.querySelectorAll('[data-acq-step]');
    for (var i = 0; i < nodes.length; i++) {
      this.steps[nodes[i].getAttribute('data-acq-step')] = nodes[i];
    }

    this.bar = root.querySelector('[data-acq-bar]');
    this.progressText = root.querySelector('[data-acq-progress-text]');
    this.backBtn = root.querySelector('[data-acq-back]');
    this.restartBtn = root.querySelector('[data-acq-restart]');

    this.bindEvents();
    this.go(this.startId, { replace: true, focus: false });
  }

  AdapterClampQuiz.prototype.bindEvents = function () {
    var self = this;

    this.root.addEventListener('click', function (event) {
      var choice = event.target.closest('[data-acq-goto]');
      if (choice && self.root.contains(choice)) {
        event.preventDefault();
        self.go(choice.getAttribute('data-acq-goto'));
        return;
      }

      var pick = event.target.closest('[data-acq-select-variant]');
      if (pick && self.root.contains(pick)) {
        event.preventDefault();
        self.selectVariant(pick);
        return;
      }

      var zoom = event.target.closest('[data-acq-zoom]');
      if (zoom && self.root.contains(zoom)) {
        event.preventDefault();
        self.openLightbox(zoom);
      }
    });

    if (this.backBtn) {
      this.backBtn.addEventListener('click', function () {
        self.back();
      });
    }

    if (this.restartBtn) {
      this.restartBtn.addEventListener('click', function () {
        self.restart();
      });
    }
  };

  AdapterClampQuiz.prototype.go = function (id, options) {
    options = options || {};
    var next = this.steps[id];
    if (!next) return;

    if (this.current && !options.replace) {
      this.history.push(this.current);
    }

    for (var key in this.steps) {
      if (Object.prototype.hasOwnProperty.call(this.steps, key)) {
        this.steps[key].hidden = key !== id;
      }
    }

    this.current = id;
    this.updateChrome();

    if (options.focus !== false) {
      // Move focus to the new step so keyboard and screen-reader users are not
      // left on a button that has just been hidden.
      var heading = next.querySelector('[data-acq-focus]') || next;
      heading.focus({ preventScroll: true });

      var rect = this.root.getBoundingClientRect();
      if (rect.top < 0) {
        this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  AdapterClampQuiz.prototype.back = function () {
    if (!this.history.length) return;
    var previous = this.history.pop();
    this.current = null;
    this.go(previous, { replace: true });
  };

  AdapterClampQuiz.prototype.restart = function () {
    var picks = this.root.querySelectorAll('[data-acq-select-variant]');
    for (var i = 0; i < picks.length; i++) {
      picks[i].disabled = false;
      picks[i].textContent = 'Choose this option';
    }
    this.history = [];
    this.current = null;
    this.go(this.startId, { replace: true });
  };

  AdapterClampQuiz.prototype.updateChrome = function () {
    var step = this.steps[this.current];
    var isResult = step.hasAttribute('data-acq-result');
    var answered = this.history.length;

    // Paths through this quiz are 2-5 questions long, so a fixed step count
    // would be wrong on most routes. Each question declares how many more
    // questions the longest remaining path holds, which lets the bar reach
    // 100% on every route without ever going backwards.
    var remaining = parseInt(step.getAttribute('data-acq-depth'), 10) || 0;
    var percent = isResult ? 100 : Math.round((answered / (answered + remaining)) * 100);

    if (this.bar) {
      this.bar.style.width = percent + '%';
      var container = this.bar.parentNode;
      if (container && container.setAttribute) {
        container.setAttribute('aria-valuenow', String(percent));
      }
    }

    if (this.progressText) {
      this.progressText.textContent = isResult
        ? this.progressText.getAttribute('data-acq-done-text') || 'Your result'
        : percent + '% complete';
    }

    if (this.backBtn) {
      this.backBtn.hidden = this.history.length === 0;
    }

    if (this.restartBtn) {
      this.restartBtn.hidden = !isResult;
    }
  };

  /* --- variant selection (compact / product-page layout) ---------------- */

  /**
   * The compact layout sits on the product page, so instead of showing a card
   * for a product the customer is already looking at, we set the variant picker
   * for them.
   *
   * The picker's radio inputs carry the variant TITLE as their value - the same
   * titles the Liquid matches on - so we match by title rather than by ID. IDs
   * differ on every region store; the titles are identical across all five.
   *
   * If the picker is not on the page or its markup has changed, fall back to a
   * plain ?variant= navigation, which Shopify honours natively. Worst case the
   * customer gets a page load, never a dead button.
   */
  AdapterClampQuiz.prototype.selectVariant = function (btn) {
    var title = btn.getAttribute('data-acq-select-variant');
    var inputs = document.querySelectorAll('product-option-picker input[type="radio"]');
    var hit = null;

    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === title) { hit = inputs[i]; break; }
    }

    if (!hit) {
      var url = btn.getAttribute('data-acq-variant-url');
      if (url) window.location.href = url;
      return;
    }

    // Click the label rather than the input: the theme's <product-option-picker>
    // hides the input and reacts to the label, and setting .checked directly
    // fires no event at all.
    var label = null;
    var labels = document.querySelectorAll('label');
    for (var j = 0; j < labels.length; j++) {
      if (labels[j].htmlFor === hit.id) { label = labels[j]; break; }
    }
    (label || hit).click();

    // Confirm it actually took, rather than assuming.
    var self = this;
    window.setTimeout(function () {
      var applied = hit.checked;
      btn.textContent = applied
        ? (btn.getAttribute('data-acq-chosen-text') || 'Selected')
        : 'Choose this option';
      btn.disabled = applied;
      if (!applied) {
        var url = btn.getAttribute('data-acq-variant-url');
        if (url) window.location.href = url;
        return;
      }
      var picker = document.querySelector('product-option-picker');
      if (picker && picker.scrollIntoView) {
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      self.root.dispatchEvent(new CustomEvent('acq:variant-selected', {
        bubbles: true, detail: { title: title }
      }));
    }, 250);
  };

  /* --- lightbox --------------------------------------------------------- */

  AdapterClampQuiz.prototype.openLightbox = function (trigger) {
    var self = this;
    var src = trigger.getAttribute('data-acq-zoom-src') || trigger.getAttribute('src');
    if (!src) return;

    if (!this.lightbox) {
      this.lightbox = document.createElement('div');
      this.lightbox.className = 'acq__lightbox';
      this.lightbox.setAttribute('role', 'dialog');
      this.lightbox.setAttribute('aria-modal', 'true');
      this.lightbox.innerHTML =
        '<button type="button" class="acq__lightbox-close" aria-label="Close">&times;</button><img alt="">';
      this.root.appendChild(this.lightbox);

      this.lightbox.addEventListener('click', function (event) {
        if (event.target === self.lightbox || event.target.closest('.acq__lightbox-close')) {
          self.closeLightbox();
        }
      });

      this.escHandler = function (event) {
        if (event.key === 'Escape') self.closeLightbox();
      };
    }

    var img = this.lightbox.querySelector('img');
    img.setAttribute('src', src);
    img.setAttribute('alt', trigger.getAttribute('alt') || '');

    this.lightboxReturnFocus = trigger;
    this.lightbox.hidden = false;
    document.addEventListener('keydown', this.escHandler);
    this.lightbox.querySelector('.acq__lightbox-close').focus();
  };

  AdapterClampQuiz.prototype.closeLightbox = function () {
    if (!this.lightbox || this.lightbox.hidden) return;
    this.lightbox.hidden = true;
    document.removeEventListener('keydown', this.escHandler);
    if (this.lightboxReturnFocus) {
      this.lightboxReturnFocus.focus();
    }
  };

  /* --- boot ------------------------------------------------------------- */

  function init(scope) {
    var roots = (scope || document).querySelectorAll(INSTANCE_SELECTOR);
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].hasAttribute('data-acq-ready')) {
        roots[i].setAttribute('data-acq-ready', '');
        new AdapterClampQuiz(roots[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Re-initialise when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
